import ClientWebservice from './ClientWebService';
import { blumarWebserviceAxios } from './HttpHelper';

let axios = blumarWebserviceAxios();

export default class HotelInfoService extends ClientWebservice{
	constructor(client){
		super('/hotels');
		this.auth = {
				username: client.login,
				password: client.key
		}
	};

	getHotelInfo(hotelId, lang){
		return axios.get(`${this.url}/${hotelId}`, { params:{languageCode : lang}, auth: this.auth});
	}
}



// WEBPACK FOOTER //
// ./src/services/HotelInfoService.js